const Icon = (color) => {
//   return `<svg width="32" height="48" viewBox="0 0 32 48" fill="${color}" xmlns="http://www.w3.org/2000/svg">
//     <circle cx="16" cy="15" r="15"/>
//     <path d="M10 28l6 10l6 -10Z"/>
//     <circle cx="16" cy="15" r="12" fill="#680"/>
// </svg>`;
  return `<svg width="32" height="48" viewBox="0 0 32 48" fill="${color}" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1238 23.5894C24.2366 22.2147 28 17.5468 28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 17.5468 7.76344 22.2147 12.8762 23.5894L16 29L19.1238 23.5894Z"/>
    <circle cx="27" cy="5" r="5" fill="#0f0"/>
</svg>`
};
export default Icon;
